/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeRpc
 */
import * as References from './PersonalizeRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeRpc#createPersonalization
 */
export const CREATE_PERSONALIZATION_MUTATION_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeRpc_createPersonalization';
export const CREATE_PERSONALIZATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_PERSONALIZATION_MUTATION_FIELD_NAME,
  args: ['personalizationStrategyId', 'variantName', 'segmentIdentifier', 'targetingConfig', 'assetCoordinates'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createPersonalizationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeRpc#createPersonalizationForContent
 */
export const CREATE_PERSONALIZATION_FOR_CONTENT_MUTATION_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeRpc_createPersonalizationForContent';
export const CREATE_PERSONALIZATION_FOR_CONTENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_PERSONALIZATION_FOR_CONTENT_MUTATION_FIELD_NAME,
  args: ['personalizationStrategyId', 'categoryId', 'contentId', 'segmentIdentifier', 'targetingConfig', 'assetCoordinates'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.createPersonalizationForContentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeRpc#createPersonalizationStrategyForContent
 */
export const CREATE_PERSONALIZATION_STRATEGY_FOR_CONTENT_MUTATION_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeRpc_createPersonalizationStrategyForContent';
export const CREATE_PERSONALIZATION_STRATEGY_FOR_CONTENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_PERSONALIZATION_STRATEGY_FOR_CONTENT_MUTATION_FIELD_NAME,
  args: ['contentId', 'categoryId', 'assetCoordinates'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.createPersonalizationStrategyForContentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeRpc#createPersonalizationStrategy
 */
export const CREATE_PERSONALIZATION_STRATEGY_MUTATION_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeRpc_createPersonalizationStrategy';
export const CREATE_PERSONALIZATION_STRATEGY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_PERSONALIZATION_STRATEGY_MUTATION_FIELD_NAME,
  args: ['assetCoordinates'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.createPersonalizationStrategyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeRpc#getPersonalization
 */
export const GET_PERSONALIZATION_QUERY_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeRpc_getPersonalization';
export const GET_PERSONALIZATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PERSONALIZATION_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getPersonalizationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeRpc#getPersonalizationStrategy
 */
export const GET_PERSONALIZATION_STRATEGY_QUERY_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeRpc_getPersonalizationStrategy';
export const GET_PERSONALIZATION_STRATEGY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PERSONALIZATION_STRATEGY_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getPersonalizationStrategyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeRpc#getTotalStrategiesCount
 */
export const GET_TOTAL_STRATEGIES_COUNT_QUERY_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeRpc_getTotalStrategiesCount';
export const GET_TOTAL_STRATEGIES_COUNT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TOTAL_STRATEGIES_COUNT_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getTotalStrategiesCountRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeRpc#getSegmentPersonalizationSuggestions
 */
export const GET_SEGMENT_PERSONALIZATION_SUGGESTIONS_QUERY_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeRpc_getSegmentPersonalizationSuggestions';
export const GET_SEGMENT_PERSONALIZATION_SUGGESTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SEGMENT_PERSONALIZATION_SUGGESTIONS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getSegmentPersonalizationSuggestionsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeRpc#listPersonalizedAssets
 */
export const LIST_PERSONALIZED_ASSETS_QUERY_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeRpc_listPersonalizedAssets';
export const LIST_PERSONALIZED_ASSETS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_PERSONALIZED_ASSETS_QUERY_FIELD_NAME,
  args: ['filter', 'sort', 'pageLength', 'offset', 'assetSource'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.listPersonalizedAssetsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeRpc#updatePersonalizationStrategy
 */
export const UPDATE_PERSONALIZATION_STRATEGY_MUTATION_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeRpc_updatePersonalizationStrategy';
export const UPDATE_PERSONALIZATION_STRATEGY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_PERSONALIZATION_STRATEGY_MUTATION_FIELD_NAME,
  args: ['id', 'personalizationWriteObjects'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.updatePersonalizationStrategyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});